import React from "react";

const DeactivateUser = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36.895"
      height="37.719"
      viewBox="0 0 36.895 37.719"
    >
      <g
        id="Group_6379"
        data-name="Group 6379"
        transform="translate(-746.105 -425.281)"
      >
        <path
          id="Subtraction_3"
          data-name="Subtraction 3"
          d="M18725.2-14985.562H18704a16.791,16.791,0,0,1,16.771-16.771h1.52a16.66,16.66,0,0,1,9.605,3.029,10.45,10.45,0,0,0-7.371,10.025,10.478,10.478,0,0,0,.676,3.716Zm-3.674-17.6a8.432,8.432,0,0,1-8.422-8.421,8.429,8.429,0,0,1,8.422-8.416,8.428,8.428,0,0,1,8.42,8.416A8.43,8.43,0,0,1,18721.529-15003.161Z"
          transform="translate(-17957.895 15445.279)"
          fill="#404040"
        />
        <circle
          id="Ellipse_386"
          data-name="Ellipse 386"
          cx="7.5"
          cy="7.5"
          r="7.5"
          transform="translate(768 448)"
          fill="#404040"
        />
        <line
          id="Line_370"
          data-name="Line 370"
          y1="7"
          x2="6.498"
          transform="translate(772.25 452)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="1.3"
        />
      </g>
    </svg>
  );
};

export default DeactivateUser;
